import React from "react";
import { Route, BrowserRouter, Routes, Navigate } from "react-router-dom";
import Cadastro from "./ui/modules/auth/Cadastro";
import CadastroConfirmacao from "./ui/modules/auth/CadastroConfirmacao";
import Login from "./ui/modules/auth/Login";
import RedefinirSenha from "./ui/modules/auth/RedefinirSenha";
import HomePlantar from "./ui/modules/Plantar/Home";
import HomeMinhasArvores from "./ui/modules/MinhasArvores/Home";
import HomeGrupos from "./ui/modules/Grupos/Home";
import HomeDoar from "./ui/modules/Doar/Home";
import HomeForum from "./ui/modules/Forum/Home";
import HomePerfil from "./ui/modules/Perfil/Home";
import AdminPainel from "./ui/modules/Admin/Painel";
import AdminUsuarios from "./ui/modules/Admin/Usuarios";
import AdminGrupos from "./ui/modules/Admin/Grupos";
import AdminPedidos from "./ui/modules/Admin/Pedidos";
import AdminConteudo from "./ui/modules/Admin/Conteudo";
import AdminConteudoLista from "./ui/modules/Admin/Conteudo/Lista";
import AdminConteudoForm from "./ui/modules/Admin/Conteudo/Form";
import Grupos from "./ui/modules/Grupos/Grupos";
import ConhecerGrupo from "./ui/modules/Grupos/ConhecerGrupo";
import HomeMapa from "./ui/modules/Mapa/Home";
import HomeConfiguracoes from "./ui/modules/Configuracoes/Home";
import AdminRelatorios from "./ui/modules/Relatorios/Home";

import { useEffect } from "react";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "./utils/config";
import Usuario from "./models/Usuario";
import { AppDownload } from "./ui/modules/AppDowload";
import Termos from "./ui/modules/Termos/Home";
import ExcluirConta from "./ui/modules/auth/ExcluirConta";
import RotaAdministrador from "./ui/components/RotaAdministrador";

const RoutesApp = ({setUsuario}) => {
  const path = window.location.pathname;

  function isMobileDevice() {
    const userAgent = navigator.userAgent;
    const mobileKeywords = ["Mobile", "Android", "iPhone", "iPad", "Windows Phone"];

    return mobileKeywords.some((keyword) => userAgent.includes(keyword));
  }

  async function  getUsuario(){
    const usuario_json = JSON.parse(sessionStorage.getItem('usuario'));
    const usuario = await Usuario.findById(usuario_json.id);
    if(usuario.data){
      setUsuario(usuario.data);
    }
  }
  
  useEffect(() => {
    const path_free = ['/login', '/cadastro', '/redefinir-senha', '/app-download', '/termos-de-uso', '/excluir-conta'];
    if (!path_free.includes(path) && !sessionStorage.getItem('usuario')) {
      window.location.href = "/login";
    }else if(!path_free.includes(path)){
      getUsuario();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);


 
  return (
    !isMobileDevice() || path === '/redefinir-senha' ?
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/redefinir-senha" element={<RedefinirSenha />} />
        <Route path="/cadastro/confirmacao" element={<CadastroConfirmacao />} />
        <Route path="/plantar" element={<HomePlantar />} />
        <Route path="/minhas-arvores" element={<HomeMinhasArvores />} />
        <Route path="/minhas-arvores/atualizar/:plantio_id" element={<HomePlantar/>} />
        <Route path="/grupos" element={<HomeGrupos />} />
        <Route path="/grupos/:id/conhecer" element={<ConhecerGrupo />} />
        <Route path="/grupos/:id" element={<Grupos />} />
        <Route path="/doar" element={<HomeDoar />} />
        <Route path="/forum" element={<HomeForum />} />
        <Route path="/perfil" element={<HomePerfil />} />
        <Route path="/mapa" element={<HomeMapa/>} />
        <Route path="/configuracoes" element={<HomeConfiguracoes />} />
        {/* Ambiente do administrador, separado da jornada do usuário. Cada rota
            passa pela RotaAdministrador; o backend é quem barra de verdade. */}
        <Route path="/admin" element={<RotaAdministrador><AdminPainel /></RotaAdministrador>} />
        <Route path="/admin/relatorios" element={<RotaAdministrador><AdminRelatorios /></RotaAdministrador>} />
        <Route path="/admin/usuarios" element={<RotaAdministrador><AdminUsuarios /></RotaAdministrador>} />
        <Route path="/admin/grupos" element={<RotaAdministrador><AdminGrupos /></RotaAdministrador>} />
        <Route path="/admin/pedidos" element={<RotaAdministrador><AdminPedidos /></RotaAdministrador>} />
        <Route path="/admin/conteudo" element={<RotaAdministrador><AdminConteudo /></RotaAdministrador>} />
        {/* Cada cadastro tem página própria: lista em largura total e formulários
            de criar/editar como páginas (sem modais). */}
        {/* O formulário do apoiador deixou de existir: quem quer apoiar pede pelo app (ver Pedidos). */}
        <Route path="/admin/conteudo/formulario" element={<Navigate to="/admin/conteudo" replace />} />
        <Route path="/admin/conteudo/:recurso" element={<RotaAdministrador><AdminConteudoLista /></RotaAdministrador>} />
        <Route path="/admin/conteudo/:recurso/novo" element={<RotaAdministrador><AdminConteudoForm /></RotaAdministrador>} />
        <Route path="/admin/conteudo/:recurso/:id/editar" element={<RotaAdministrador><AdminConteudoForm /></RotaAdministrador>} />
        {/* Endereços antigos continuam valendo (favoritos, links). */}
        <Route path="/gerenciamento" element={<Navigate to="/admin/conteudo" replace />} />
        <Route path="/relatorios" element={<Navigate to="/admin/relatorios" replace />} />
        <Route path="/termos-de-uso" element={<Termos />} />
        <Route path="/excluir-conta" element={<ExcluirConta />} />
      </Routes>
    </BrowserRouter>
  : <AppDownload/>);
};

export default connect(mapStateToProps, mapDispatchToProps)(RoutesApp);
